import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SettingsPage } from './settings';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.

@NgModule({
  declarations: [
    SettingsPage,
  ],
  imports: [
    IonicPageModule.forChild(SettingsPage),
    TranslateModule.forChild() // Required for translation.
  ],
  exports: [
    SettingsPage
  ]
})
export class SettingsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.module.ts